/* eslint-disable @typescript-eslint/no-explicit-any */
import { DocsSections } from '@components/Docs/types';
import { baseClient } from '@store/index';

export const getDocumentation = async () => {
  const response = await baseClient.get(`/docs`);

  if (response?.data?.error) throw new Error(JSON.stringify(response.data.error));
  if (response?.data) return response?.data as DocsSections[];

  throw new Error(`There was no sections found in the database.`);
};
